import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Lang } from '../types';
interface GalleryCarouselProps {
  lang: Lang;
}
const images = [{
  src: 'https://cdn.magicpatterns.com/uploads/3ufoLyBwjPRQ1hA4YmWmiX/467879966_18028434881393787_5776615547924424798_n.jpg',
  alt: 'Tattoo sleeve — skull & mandala'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bv3TG6bDtiGVrfnMnqnaah/484370911_18160809022341686_1779723690504867755_n.jpg',
  alt: 'Tattoo — lion & portrait'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qpsCSwksYiZBmc9TmSHvR5/489034991_18163249150341686_693240776012045429_n.jpg',
  alt: 'Tattoo — mandala & floral'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/gYUG5wL5gDj8SH8Cm4eGGn/491225603_1748095029108086_240616346185405254_n.jpg',
  alt: 'Tattoo — colorful floral sleeve'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/up7jrv21RWHEJpMp422yof/491325230_18164465830341686_7961157127155896631_n.jpg',
  alt: 'Tattoo — neo-traditional leg piece'
}];
const content = {
  en: {
    label: 'Gallery',
    title: 'Passion Becomes Art'
  },
  es: {
    label: 'Galería',
    title: 'La Pasión Se Convierte en un Arte'
  }
};
export function GalleryCarousel({
  lang
}: GalleryCarouselProps) {
  const t = content[lang];
  // Duplicate images for seamless infinite loop
  const allImages = [...images, ...images];
  return <section id="gallery" className="pt-0 pb-6 bg-studio-bg border-b border-studio-border overflow-hidden" data-id="element-189">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-12 px-6" data-id="element-190">
        <p className="text-studio-accent uppercase tracking-[0.3em] text-sm mb-4 font-inter font-medium" data-id="element-191">
          ✦ &nbsp; {t.label} &nbsp; ✦
        </p>
        <h2 className="text-3xl md:text-5xl font-bold font-playfair italic text-studio-text" data-id="element-192">
          {t.title}
        </h2>
        <div className="w-16 h-px bg-studio-accent mx-auto mt-6" data-id="element-193" />
      </motion.div>

      {/* Marquee container */}
      <div className="relative" data-id="element-194">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-r from-studio-bg to-transparent z-10 pointer-events-none" data-id="element-195" />
        <div className="absolute right-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-l from-studio-bg to-transparent z-10 pointer-events-none" data-id="element-196" />

        {/* Scrolling track */}
        <div className="flex gap-6 animate-marquee" data-id="element-197">
          {allImages.map((img, i) => <div key={i} className="flex-shrink-0 w-64 h-80 md:w-72 md:h-96 rounded-lg overflow-hidden border border-studio-border group" data-id="element-198">
              <img src={img.src} alt={img.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" data-id="element-199" />
            </div>)}
        </div>
      </div>
    </section>;
}